<template>
  <main class="main-page" style="height: 100%">
    <v-container fluid style="height: 100%">
      <v-row
        align="center"
        justify="center"
        style="height: 100%"
        v-if="isLoading"
      >
        <RingLoader color="#7ed321" />
      </v-row>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="#7ed321" elevation="0">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>เพิ่มบัญชี</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-form @submit="submit" ref="form" v-model="valid">
            <v-row class="pa-2">
              <v-col cols="12">
                <h2 style="color: #7ed321">บัญชีฝากเงิน</h2>
                <br />
                <v-select
                  v-model="select"
                  :items="itemsBankprovider"
                  :error-messages="selectErrors"
                  label="กรุณาเลือกธนาคาร"
                  required
                  solo-inverted
                  return-object
                  @change="$v.select.$touch()"
                  @blur="$v.select.$touch()"
                  hide-details
                  ><template slot="selection" slot-scope="data">
                    <img width="20px" class="mr-2" :src="data.item.logo" />
                    {{ data.item.name }}
                    ({{ data.item.shortname }})
                  </template>
                  <template slot="item" slot-scope="data">
                    <img width="30px" class="mr-2" :src="data.item.logo" />
                    {{ data.item.name }}
                    ({{ data.item.shortname }})
                  </template></v-select
                >
                <v-row style="margin-bottom: 5px">
                  <v-col cols="12" style="color: #7ed321; font-size: 12px"
                    >Bank account
                  </v-col>
                </v-row>
                <v-text-field
                  v-if="select"
                  v-model="bankAcc"
                  :error-messages="bankAccErrors"
                  :rules="[rules.bankAccRule(bankAcc, select)]"
                  label="กรุณาใส่เลขบัญชี"
                  required
                  solo-inverted
                  @input="$v.bankAcc.$touch()"
                  @blur="$v.bankAcc.$touch()"
                  hide-details
                ></v-text-field>
                <v-row v-if="select" style="margin-bottom: 5px">
                  <v-col cols="12" style="color: #7ed321; font-size: 12px"
                    >Account number
                  </v-col>
                </v-row>
                <!-- <v-text-field
                  v-model="firstnameTh"
                  :error-messages="firstnameThErrors"
                  label="กรุณาใส่ชื่อภาษาไทย"
                  required
                  solo-inverted
                  :rules="[rules.firstnameThRule]"
                  @input="$v.firstnameTh.$touch()"
                  @blur="$v.firstnameTh.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="lastnameTh"
                  :error-messages="lastnameThErrors"
                  label="กรุณาใส่นามสกุลภาษาไทย"
                  required
                  solo-inverted
                  :rules="[rules.lastnameThRule]"
                  @input="$v.lastnameTh.$touch()"
                  @blur="$v.lastnameTh.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="firstnameEn"
                  :error-messages="firstnameEnErrors"
                  label="กรุณาใส่ชื่อภาษาอังกฤษ"
                  required
                  solo-inverted
                  :rules="[rules.firstnameEnRule]"
                  @input="$v.firstnameEn.$touch()"
                  @blur="$v.firstnameEn.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="lastnameEn"
                  :error-messages="lastnameEnErrors"
                  label="กรุณาใส่นามสกุลภาษาอังกฤษ"
                  required
                  solo-inverted
                  :rules="[rules.lastnameEnRule]"
                  @input="$v.lastnameEn.$touch()"
                  @blur="$v.lastnameEn.$touch()"
                ></v-text-field> -->
                <v-btn
                  block
                  elevation="2"
                  x-large
                  @click="addAccount()"
                  :style="!$v.$invalid ? 'background-color: #7ed321' : ''"
                  :disabled="$v.$invalid || !valid"
                  >ยืนยันการเพิ่มบัญชี</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="isDelete" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h5"> ลบบัญชี </v-card-title>
          <v-card-text>ยืนยันการลบบัญชี?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="isDelete = false">
              ยกเลิก
            </v-btn>
            <v-btn color="green darken-1" text @click="deleteAccount()">
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div id="manage-account" v-if="!isLoading">
        <Avatar :img="img" :displayName="displayName"></Avatar>
      </div>
      <template>
        <div>
          <v-tabs v-model="active">
            <v-tab value="1" ripple @click="getPlayerAccount(lineId)"
              >บัญชีธนาคาร</v-tab
            >
            <v-tab-item vlue="1">
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-row align="center" justify="center">
                    <v-col cols="12" align="end">
                      <v-btn @click="dialog = true">เพิ่มบัญชี</v-btn>
                    </v-col>
                    <v-col cols="12" class="pa-0">
                      <v-data-table
                        :headers="headers_account"
                        :items="accounts_list"
                        :items-per-page="5"
                        class="elevation-1"
                        mobile-breakpoint="0"
                      >
                        <template v-slot:[`item.bank_name`]="{ item }">
                          <img
                            :src="item.bank_name"
                            style="width: 25px; height: 25px"
                          />
                        </template>
                        <template v-slot:[`item.action`]="{ item }">
                          <v-btn
                            color="error"
                            @click="openDialogDelete(item)"
                            v-if="item.status == 'ใช้งานได้'"
                            >ลบ</v-btn
                          >
                        </template>
                      </v-data-table></v-col
                    >
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab value="2" ripple @click="getTransactionAccount(lineId)"
              >ประวัติรายการ</v-tab
            >
            <v-tab-item vlue="2">
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-row align="center" justify="center">
                    <v-col cols="12">
                      <v-data-table
                        :headers="headers_history"
                        :items="history_list"
                        :items-per-page="5"
                        class="elevation-1"
                        mobile-breakpoint="0"
                      >
                        <template v-slot:[`item.datetime`]="{ item }">
                          {{ new Date(item.datetime).toLocaleString() }}
                        </template>
                        <template v-slot:[`item.account`]="{ item }">
                          <img
                            :src="item.bank_name"
                            style="width: 25px; height: 25px"
                          />{{ item.account_no }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab value="3" ripple @click="getIssue(lineId)"
              >การแจ้งปัญหา</v-tab
            >
            <v-tab-item vlue="3">
              <v-card flat>
                <v-card-text class="pa-0">
                  <v-col cols="12" class="pa-0">
                    <v-data-table
                      :headers="headers_problem"
                      :items="problem_list"
                      :items-per-page="5"
                      class="elevation-1"
                      mobile-breakpoint="0"
                    >
                      <template v-slot:[`item.datetime`]="{ item }">
                        {{ new Date(item.datetime).toLocaleString() }}
                      </template>
                      <template v-slot:[`item.account`]="{ item }">
                        <img
                          :src="item.account.img"
                          style="
                            width: 25px;
                            height: 25px;
                            margin-right: 15px;
                            vertical-align: middle;
                          "
                        />{{ item.account.account_no }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </template></v-container
    >
  </main>
</template>

<script>
import Avatar from "../components/Avatar";
import liff from "@line/liff";
import { RingLoader } from "vue-spinners-css";
import playerService from "../services/player_service";
import issueService from "../services/issue_service";
import transactionService from "../services/transaction_service";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import ttb from "../assets/TTB.jpeg";
import { BANK_ACCOUNT_MAX_LENGTH, bankAccountRule } from "../config/banks.js";

export default {
  components: { Avatar, RingLoader },
  mixins: [validationMixin],
  validations: {
    bankAcc: { required, maxLength: maxLength(BANK_ACCOUNT_MAX_LENGTH) },
    select: { required },
  },
  data: () => ({
    valid: true,
    displayName: "",
    img: "",
    lineId: "",
    isLoading: false,
    isSuccess: false,
    errorMsg: "",
    firstnameTh: "",
    lastnameTh: "",
    firstnameEn: "",
    lastnameEn: "",
    bankAcc: "",
    select: null,
    itemsBankprovider: [
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FSCB.png?alt=media&token=4bcea6cf-b654-47ce-a099-7ec62c95169f",
        name: "ธนาคารไทยพาณิชย์",
        shortname: "SCB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKBNK.png?alt=media&token=9a4c15d8-ef3c-43a4-bc4e-0498b1a7fa1d",
        name: "ธนาคารกสิกรไทย",
        shortname: "KBNK",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKTBA.png?alt=media&token=f48498e0-331e-484e-98a2-99880d10cb06",
        name: "ธนาคารกรุงไทย",
        shortname: "KTB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBBLA.png?alt=media&token=f563a3e0-fcdc-4135-ac8e-878fa44eeaef",
        name: "ธนาคารกรุงเทพ",
        shortname: "BBL",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAYA.png?alt=media&token=e3c78d16-0c04-47ae-9280-867aaef46feb",
        name: "ธนาคารกรุงศรีอยุธยา",
        shortname: "BAY",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGSBA.png?alt=media&token=c0d650ae-6748-445d-bc4f-ce8843b9706c",
        name: "ธนาคารออมสิน",
        shortname: "GSBA",
      },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTMBA.png?alt=media&token=210fdf60-2efe-4043-b982-55bcba748cf0",
      //   name: "ธนาคารทหารไทย",
      //   shortname: "TMBA",
      // },
      // {
      //   logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FTBNK.jpg?alt=media&token=51a47ad4-f37c-4573-b7dd-b2dc53ad4d8a",
      //   name: "ธนาคารธนชาต",
      //   shortname: "TBNK",
      // },
      {
        logo: ttb,
        name: "ธนาคารทีเอ็มบีธนชาต",
        shortname: "TMB",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKKBA.png?alt=media&token=ac103755-a94a-40d4-afef-2383dcb73e89",
        name: "ธนาคารเกียรตินาคิน",
        shortname: "KKBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGHBA.png?alt=media&token=4caa517e-2d35-4413-8be9-ddfb09ff88b7",
        name: "ธนาคารอาคารสงเคราะห์",
        shortname: "GHBA",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAAC.png?alt=media&token=db135e19-2125-43bb-a4aa-a70b0977f744",
        name: "ธนาคารเพื่อการเกษตรและสหกรณ์",
        shortname: "BAAC",
      },
      {
        logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FUOBT.png?alt=media&token=522b8d11-670c-47f4-b431-e9f199ef1900",
        name: "ยูโอบี",
        shortname: "UOBT",
      },
    ],
    rules: {
      // firstnameThRule: (value) => {
      //   const pattern = /^[ก-๏]+$/;
      //   return pattern.test(value) || "กรุณากรอก ชื่อภาษาไทย ให้ถูกต้อง";
      // },
      // lastnameThRule: (value) => {
      //   const pattern = /^[ก-๏]+$/;
      //   return pattern.test(value) || "กรุณากรอก นามสกุลภาษาไทย ให้ถูกต้อง";
      // },
      // firstnameEnRule: (value) => {
      //   const pattern = /^[a-zA-Z]+$/;
      //   return pattern.test(value) || "กรุณากรอก ชื่อภาษาอังกฤษ ให้ถูกต้อง";
      // },
      // lastnameEnRule: (value) => {
      //   const pattern = /^[a-zA-Z]+$/;
      //   return pattern.test(value) || "กรุณากรอก นามสกุลภาษาอังกฤษ ให้ถูกต้อง";
      // },
      bankAccRule: bankAccountRule,
    },
    headers_account: [
      {
        text: "Bank",
        value: "bank_name",
        sortable: false,
      },
      { text: "Acc no.", value: "account_no", sortable: false },
      { text: "Name", value: "name", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "", value: "action", sortable: false },
    ],
    accounts_list: [],
    headers_history: [
      {
        text: "#",
        value: "no",
        sortable: false,
      },
      {
        text: "สถานะ",
        value: "is_success",
        sortable: false,
      },
      {
        text: "วัน/เวลา",
        value: "datetime",
        sortable: false,
      },
      {
        text: "บัญชี",
        value: "account",
        sortable: false,
      },
      { text: "จำนวนเงิน", value: "amount", sortable: false },
    ],
    history_list: [],
    headers_problem: [
      {
        text: "#",
        value: "id",
        sortable: false,
      },
      {
        text: "วัน/เวลา",
        value: "datetime",
        sortable: false,
      },
      {
        text: "บัญชี",
        value: "account",
        sortable: false,
      },
      { text: "จำนวนเงิน", value: "amount", sortable: false },
      { text: "สถานะ", value: "status", sortable: false },
      { text: "หมายเหตุ", value: "remark", sortable: false },
    ],
    problem_list: [],
    // tab: null
    active: null,
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false,
    isDelete: false,
    deleteList: null,
  }),
  computed: {
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("กรุณาเลือกธนาคาร");
      return errors;
    },
    // firstnameThErrors() {
    //   const errors = [];
    //   if (!this.$v.firstnameTh.$dirty) return errors;
    //   !this.$v.firstnameTh.required && errors.push("กรุณาใส่ชื่อภาษาไทย");
    //   return errors;
    // },
    // lastnameThErrors() {
    //   const errors = [];
    //   if (!this.$v.lastnameTh.$dirty) return errors;
    //   !this.$v.lastnameTh.required && errors.push("กรุณาใส่นามสกุลภาษาไทย");
    //   return errors;
    // },
    // firstnameEnErrors() {
    //   const errors = [];
    //   if (!this.$v.firstnameEn.$dirty) return errors;
    //   !this.$v.firstnameEn.required && errors.push("กรุณาใส่ชื่อภาษาอังกฤษ");
    //   return errors;
    // },
    // lastnameEnErrors() {
    //   const errors = [];
    //   if (!this.$v.lastnameEn.$dirty) return errors;
    //   !this.$v.lastnameEn.required && errors.push("กรุณาใส่นามสกุลภาษาอังกฤษ");
    //   return errors;
    // },
    bankAccErrors() {
      const errors = [];
      if (!this.$v.bankAcc.$dirty) return errors;
      !this.$v.bankAcc.required && errors.push("กรุณาใส่เลขบัญชี");
      return errors;
    },
  },
  created() {
    this.getLineLiff();
  },
  methods: {
    getLineLiff() {
      liff
        .init({
          liffId: "1657076095-KJwRrNal", // prod
          // liffId: "1657078715-18BnkoZy", //local
        })
        .then(async () => {
          if (liff.isLoggedIn()) {
            let getProfile = await liff.getProfile();
            this.displayName = getProfile.displayName;
            this.img = getProfile.pictureUrl;
            this.lineId = getProfile.userId;
            this.getPlayerAccount(this.lineId);
            this.getTransactionAccount(this.lineId);
            this.getIssue(this.lineId);
          } else {
            liff.login();
          }
        })
        .catch((err) => {
          // Error happens during initialization
          console.log(err.code, err.message);
        });
    },
    getPlayerAccount(lineId) {
      this.accounts_list = [];
      this.isLoading = true;
      playerService
        .getPlayer(lineId)
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].bankName != "") {
              this.accounts_list.push({
                id: res.data[i].id,
                bank_name: res.data[i].bankName,
                account_no: res.data[i].accountNo,
                name:
                  res.data[i].accountNameEn +
                  " " +
                  res.data[i].accountSurnameEn,
                accountNameEn: res.data[i].accountNameEn,
                accountSurnameEn: res.data[i].accountSurnameEn,
                status:
                  res.data[i].status == "active" ? "ใช้งานได้" : "รอตรวจสอบ",
              });
            }
          }
          for (let j = 0; j < this.accounts_list.length; j++) {
            for (let k = 0; k < this.itemsBankprovider.length; k++) {
              if (
                this.accounts_list[j].bank_name ==
                this.itemsBankprovider[k].shortname
              ) {
                this.accounts_list[j].bank_name =
                  this.itemsBankprovider[k].logo;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.response.data.display_message;
          this.$toast.error(error.response.data.display_message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          this.errored = true;
        });
    },
    getTransactionAccount(lineId) {
      this.history_list = [];
      this.isLoading = true;
      transactionService
        .getTransaction(lineId)
        .then((res) => {
          for (let i = 0; i < res.data.transactions.length; i++) {
            this.history_list.push({
              no: i + 1,
              datetime: res.data.transactions[i].createdAt,
              account_no: res.data.transactions[i].accountNo,
              bank_name: res.data.transactions[i].bankName,
              amount: res.data.transactions[i].amount,
              is_success : res.data.transactions[i].isSuccessed?"success":"pending"
            });
          }
          for (let j = 0; j < this.history_list.length; j++) {
            for (let k = 0; k < this.itemsBankprovider.length; k++) {
              if (
                this.history_list[j].bank_name ==
                this.itemsBankprovider[k].shortname
              ) {
                this.history_list[j].bank_name = this.itemsBankprovider[k].logo;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.response.data.display_message;
          this.$toast.error(error.response.data.display_message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          this.errored = true;
        });
    },
    getIssue(lineId) {
       this.problem_list = [];
      this.isLoading = true;
      issueService
        .getIssue(lineId)
        .then((res) => {
          let data = res.data;
          console.log(data);
          for (let i = 0; i < data.issues.length; i++) {
            this.problem_list.push({
              no: i + 1,
              id: data.issues[i].id,
              datetime: data.issues[i].transactionDate,
              account: {
                img: data.issues[i].bankName,
                account_no: data.issues[i].accountNo,
              },
              amount: data.issues[i].amount,
              status:
                data.issues[i].status == "processing"
                  ? "กำลังตรวจสอบ"
                  : data.issues[i].status == "pending"
                  ? "กำลังตรวจสอบ"
                  : data.issues[i].status == "reject"
                  ? "ยกเลิกรายการ"
                  : data.issues[i].status == "refund"
                  ? "คืนเงินให้แล้ว"
                  : data.issues[i].status,
              remark:
                data.issues[i].description == ""
                  ? "-"
                  : data.issues[i].description,
            });
          }

          for (let j = 0; j < this.problem_list.length; j++) {
            for (let k = 0; k < this.itemsBankprovider.length; k++) {
              if (
                this.problem_list[j].account.img ==
                this.itemsBankprovider[k].shortname
              ) {
                this.problem_list[j].account.img =
                  this.itemsBankprovider[k].logo;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.response.data.display_message;
          this.$toast.error(error.response.data.display_message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          this.errored = true;
        });
    },
    addAccount() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        // this.submitStatus = "ERROR";
        return;
      } else {
        this.dialog = false;
        this.isLoading = true;
        let body = {
          username: "",
          bankname: this.select.shortname,
          accountno: this.bankAcc,
          accountNameEn: "",
          accountSurnameEn: "",
          accountNameTh: "",
          accountSurnameTh: "",
          lineId: this.lineId,
        };
        playerService
          .addAccount(body)
          .then((res) => {
            this.isLoading = false;
            this.$toast.success(res.data.message, {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            this.getPlayerAccount(this.lineId);
            //console.log(res);
            // setTimeout(() => {
            //   liff.closeWindow();
            // }, 3000);
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error.response.data.display_message);
            // this.errorMsg = error.response.data.display_message;
            this.$toast.error(error.response.data.display_message, {
              position: "top-center",
              timeout: 5000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false,
            });
            this.errored = true;
          });
      }
    },
    openDialogDelete(item) {
      this.deleteList = item;
      this.isDelete = true;
    },
    deleteAccount() {
      this.isDelete = false;
      if (this.deleteList.status != "ใช้งานได้") {
        this.$toast.error("ไม่สามารถลบบัญชีได้ กรุณาติดต่อ Admin", {
          position: "top-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
        return;
      }
      this.isLoading = true;
      playerService
        .deleteAccount(this.deleteList.id)
        .then((res) => {
          this.isLoading = false;
          this.$toast.success(res.data.message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          //console.log(res);
          this.getPlayerAccount(this.lineId);
          // setTimeout(() => {
          //   liff.closeWindow();
          // }, 3000);
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          // this.errorMsg = error.response.data.display_message;
          this.$toast.error(error.response.data.display_message, {
            position: "top-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false,
          });
          this.errored = true;
        });
    },
  },
};
</script>

<style>
.v-slide-group__prev {
  display: none !important;
}
</style>
